/** @jsx h */
import { h } from "hyperapp";

const Advertisement = ({ advertisement }) => {
  return advertisement.image_url ? (
    <div class="player-advertisement">
      <a
        id="ad-desktop_and_mobile_player"
        href={advertisement.target_url}
        target="_blank"
        rel="noopener noreferrer"
        ga-on="click,auxclick,contextmenu"
        ga-event-category="ad"
        ga-event-action="click"
        ga-event-label={advertisement.campaign_name}
      >
        <img src={advertisement.image_url} alt={advertisement.campaign_name} />
      </a>
    </div>
  ) : null;
};

export default Advertisement;
